export const PT: Record<string, string> = {
  "Recommended for you": "Recomendado para você",
  "Resource added to favorite": "Recurso adicionado aos favoritos",
  "Failed to add resource to favorite": "Falha ao adicionar recurso aos favoritos",
  "Resource removed from favorite": "Recurso removido dos favoritos",
  "Failed to remove resource from favorite": "Falha ao remover recurso dos favoritos",
  "Calendar": "Calendário",
  "View Detail": "Ver detalhes",
  "Add to favorites": "Adicionar aos favoritos",
  "Remove from favorites": "Remover dos favoritos",
  "Description: VIP meeting room with a great view and comfortable chairs.": "Descrição: Sala de reuniões VIP com uma bela vista e cadeiras confortáveis.",
  
  // NoResultFound
  // case default resource type
  "There are no available resources at the chosen time at your location or in your favorites.": "Não há recursos disponíveis no horário escolhido em sua localização ou em seus favoritos.",
  "You have these options:": "Você tem estas opções:",
  "Change the meeting time.": "Alterar o horário da reunião.",
  "Use the <1>Find Available Time</1> button to choose a new time.": "Use o botão <1>Encontrar horário disponível</1> para escolher um novo horário.",
  "Open the search to find other resources.": "Abra a pesquisa para encontrar outros recursos.",
  // case not default resource type
  "The resource type <1>'{{resourceType}}'</1> does not exist on your default location": "O tipo de recurso <1>'{{resourceType}}'</1> não existe na sua localização padrão",
  "The resource type <1>'{{resourceType}}'</1> can be found on a different location.": "O tipo de recurso <1>'{{resourceType}}'</1> pode ser encontrado em uma localização diferente.",
  "<1>Click here</1> to add the resource type to your default location settings.": "<1>Clique aqui</1> para adicionar o tipo de recurso às suas configurações de localização padrão.",
  
  // ResourceCard
  "New Order": "Novo pedido",
  "When booking a Pooled Resource, only this resource type and only one can be booked.": "Ao reservar um Recurso Agrupado, só pode ser reservado este tipo de recurso e apenas um.",
  "You cannot select both a child resource and its virtual resource at the same time.": "Não pode selecionar ao mesmo tempo um recurso filho e seu recurso virtual.",
  // Settings
  "Note:": "Nota:",
  "An Assistant Organizer can receive the same emails from Resource Central as the organizer and can handle orders on behalf of the organizer.": "Um organizador assistente pode receber os mesmos e-mails do Resource Central como o organizador e pode processar pedidos em nome do organizador.",
  "Setting updated successfully": "Configuração atualizada com sucesso",
  "Setting updated failed": "Falha na atualização da configuração",
  "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)": "@Outlook Add-in Version. 2.0.37 (SR2 1.1 - 11/18/2025)",
  
  // ModalResourceDetail
  "1 space": "1 espaço",
  "Opening hours:": "Horário de funcionamento:",
  "Buffer time {{minutes}} mins between reservations": "Tempo de buffer {{minutes}} min entre reservas",
  "Initial payment {{value}} pr.minute": "Pagamento inicial {{value}} por minuto",
  
  // FindAvailableTime
  "Total {{total}} Attendees": "Total de {{total}} participantes",
  "{{internal}} of {{total}} internal can attend.": "{{internal}} de {{total}} internos podem comparecer.",
  "{{external}} external is unknown.": "{{external}} externos são desconhecidos.",
  "Find available time": "Encontrar horário disponível",
  "Attendees": "Participantes",
  
  // HelpSetting
  "Click on Further information to visit our support site": "Clique em Mais informações para visitar nosso site de suporte",
  "Further information": "Mais informações",
  
  // LocationSetting
  "Location changed": "Localização alterada",
  "Location change failed": "Falha na alteração da localização",
  "Please select at least one location": "Selecione pelo menos uma localização",
  "Resource types": "Tipos de recursos",
  "Location": "Localização",
  "Where": "Onde",
  
  // ModalShowAttendees
  "Total": "Total",
  "Available": "Disponível",
  "Busy": "Ocupado",
  "External": "Externo",
  "Internal": "Interno",
  
  // ResourceSearch
  "Search by resource name": "Pesquisar por nome do recurso",
  "Category": "Categoria",
  "Filter by Location": "Filtrar por localização",
  "Filter by Category": "Filtrar por categoria",
  "Capacity": "Capacidade",
  "Filter by Capacity": "Filtrar por capacidade",
  "All": "Todos",
  "Filter by availability": "Filtrar por disponibilidade",
  "Sort By": "Ordenar por",
  "Loading...": "Carregando...",
  
  // SelectedResources
  "Meeting Type": "Tipo de reunião",
  "Meeting Label": "Etiqueta de reunião",
  
  // Alert (accessibility text)
  "Check icon": "Ícone de verificação",
  "Close": "Fechar",
  
  // AppConstants - searchTab
  "Resource": "Recurso",
  "Person": "Pessoa",
  
  // AppConstants - listQuestionsStart
  "Where do your meetings usually take place?": "Onde suas reuniões geralmente acontecem?",
  "To improve our recommendations for you we would like you to enter your normal location": "Para melhorar nossas recomendações para você, gostaríamos que você informasse sua localização habitual",
  "What do you use most?": "O que você usa mais?",
  "To enable quicker and better search please chose you prefered resource type": "Para permitir uma pesquisa mais rápida e melhor, escolha seu tipo de recurso preferido",
  
  // AppConstants - titlePages
  "Click on resource to pick": "Clique no recurso para selecionar",
  "Selected Resources": "Recursos selecionados",
  "Setting": "Configuração",
  "Search": "Pesquisar",
  "Find Colleague": "Encontrar colega",
  "Quick button setting": "Configuração de botão rápido",
  "Favorite": "Favorito",
  "Most Used": "Mais usados",
  "Colleagues": "Colegas",
  "Resources": "Recursos",
  
  // AppConstants - tooltipText
  "Back": "Voltar",
  "Floor Plan": "Planta baixa",
  "Expand": "Expandir",
  "Selected resources": "Recursos selecionados",
  "View details": "Ver detalhes",
  "Remove from My Favorites": "Remover dos meus favoritos",
  "Add to My Favorites": "Adicionar aos meus favoritos",
  "Remove": "Remover",
  "Favorite - Most Used": "Favorito - Mais usados",
  "Conflict": "Conflito",
  "Approved": "Aprovado",
  "Recommendeded for you": "Recomendado para você",
  
  // AppConstants - mailFlowOptions
  "Only primary organizer": "Apenas organizador principal",
  "Only assistant organizer": "Apenas organizador assistente",
  "Primary AND assistant organizer": "Organizador principal E assistente",
  
  // FindColleague
  "Enter colleague name": "Digite o nome do colega",
  "Recent work items": "Itens de trabalho recentes",
  "No data available": "Nenhum dado disponível",
  "Floorplan": "Planta baixa",
  "List nearby resources": "Lista de recursos próximos",
  "Find resource nearby": "Encontrar recurso próximo",
  "No Resources available": "Nenhum recurso disponível",
  
  // Start page
  "Next": "Próximo",
  "Failed to update default locations": "Falha ao atualizar localizações padrão",
  "Resource Type": "Tipo de recurso",
  
  // QuickSetting
  "Quick buttons updated successfully": "Botões rápidos atualizados com sucesso",
  "Quick buttons updated failed": "Falha na atualização dos botões rápidos",
  "Add more": "Adicionar mais",
  "Apply": "Aplicar",
  "Delete": "Excluir",
  "Name": "Nome",
  "Enter name": "Digite o nome",
  "Tooltip": "Dica",
  "Enter tooltip": "Digite a dica",
  "Type": "Tipo",
  "Select type": "Selecione o tipo",
  "Locations": "Localizações",
  "Select colleagues": "Selecionar colegas",
  "Select resources": "Selecionar recursos",
  
  // DefaultResourceSetting
  "Resource type changed": "Tipo de recurso alterado",
  "Resource type change failed": "Falha na alteração do tipo de recurso",
  "Default Resource Type": "Tipo de recurso padrão",
  
  // AssistantOrganizerSetting
  "Apply Successfully": "Aplicado com sucesso",
  "Apply Failed": "Falha na aplicação",
  "Assistant Organizer": "Organizador assistente",
  "Enter a part of the name to search for": "Digite parte do nome para pesquisar",
  "Mail Flow": "Fluxo de e-mail",
  "Select Mail Flow": "Selecionar fluxo de e-mail",
  
  // TileConfigurationSetting
  "Update settings successfully": "Configurações atualizadas com sucesso",
  "Update settings failed": "Falha na atualização das configurações",
  "Timeline": "Linha do tempo",
  
  // SelectCategoryForm
  "And": "E",
  "Or": "Ou",
  
  // Other
  "Resource Calendar": "Calendário de recursos",
  
  // SettingLabels
  "Default Location": "Localização padrão",
  "Quick button": "Botão rápido",
  "Category icons": "Ícones de categoria",
  "Recommendation screen": "Tela de recomendações",
  "Capacity filter": "Filtro de capacidade",
  "AI Assistant": "Assistente de IA",
  "Tile configuration": "Configuração de blocos",
  "Help": "Ajuda",
  "Default Categories": "Categorias padrão",
  
  // MeetingType
  "Your must select a Meeting label": "Você deve selecionar um rótulo de reunião",
  
  // AlternativeResource
  "Selected Resource: 'AOD_Copanhagen' Conflicting Occurrences": "Recurso selecionado: 'AOD_Copanhagen' Ocorrências conflitantes",
  "Alternative Resource": "Recurso alternativo",
  "OK": "OK",
  "Cancel": "Cancelar",
  
  // RemovedResource
  "Your selected resources 'AOD_Copenhagen' was removed": "Seu recurso selecionado 'AOD_Copenhagen' foi removido",
  "You can't book this resource as your request exceeds the available capacity.": "Você não pode reservar este recurso porque sua solicitação excede a capacidade disponível.",
  
  // ChangeTime
  "Time changed successfully": "Horário alterado com sucesso",
  "Current Time": "Horário atual",
  "Suggested Times": "Horários sugeridos",
  "Change Time": "Alterar horário",
  "people are free": "pessoas estão livres",
};

